import { type ImageConstraints } from "@/types";

const t = (msg: string) => msg;

interface GiftGuideLpItem {
  title: string;
  copy: string;
  color?: string;
  tileCopy?: string[];
  link?: string[];
  imageConstraints?: ImageConstraints;
  ctaText?: string;
  ctaLink?: string;
}

interface GiftGuideLpContent {
  hero: GiftGuideLpItem;
  section1: GiftGuideLpItem;
  section2: GiftGuideLpItem;
  section3: GiftGuideLpItem;
}

export const GiftGuideContent: GiftGuideLpContent = {
  hero: {
    title: t("Shop holiday gift guides in the LTK app"),
    copy: t(
      "Let LTK Creators take the stress out of holiday shopping, so you can focus on making this season a joyful one.",
    ),
  },
  section1: {
    title: t("Who are you shopping for?"),
    copy: t(
      "LTK is your one-stop destination this holiday season. From festive outfits and hosting ideas, to the perfect present for everyone on your list, shop Creator gift guides and exclusive savings in the LTK app.",
    ),
    color: "ltk-white",
    tileCopy: [
      t("Gift Guides"),
      t("Holiday"),
      t("Popular Today"),
      // t("LTK Cyber Week")
    ],
    link: [
      "/categories/LTKGiftGuide",
      "/categories/LTKHoliday",
      "/categories/ltkpopulartoday",
      // "/categories/LTKCyberWeek",
    ],
    imageConstraints: {
      lg: { maxWidth: "100%", maxHeight: "100%" },
      md: { maxWidth: "100%", maxHeight: "100%" },
      sm: { width: "160px", maxWidth: "160px" },
      xs: { maxWidth: "100%", maxHeight: "100%" },
    },
    ctaText: t("shop more categories"),
    ctaLink: "/categories",
  },
  section2: {
    title: t("Everything you need for a memorable holiday season"),
    copy: t(
      "Make your holiday merry and bright when you shop from LTK Creators–curated to exactly what you love or need.",
    ),
    color: "dusty-rose-10",
    imageConstraints: {
      lg: { maxWidth: "100%", maxHeight: "100%" },
      md: { maxWidth: "100%", maxHeight: "100%" },
      sm: { width: "260", height: "192", maxWidth: "100%", maxHeight: "100%" },
      xs: { width: "375", height: "225", maxWidth: "100%", maxHeight: "100%" },
    },
    ctaText: t("SHOP CREATOR PICKS"),
    ctaLink: "https://ltk.app.link/fLHsPHg3MR",
  },
  section3: {
    title: t("Shop viral gifts Creators are loving"),
    copy: t("Don't know what to buy? You can't go wrong with the “it” gifts of the season."),
    color: "ltk-white",
    imageConstraints: {
      lg: { maxWidth: "100%", maxHeight: "100%" },
      md: { maxWidth: "100%", maxHeight: "100%" },
      sm: { maxWidth: "164", maxHeight: "206" },
      xs: { maxWidth: "100%", maxHeight: "100%" },
    },
    link: [
      "/explore/hauskris/posts/917dbc14-e8de-11ec-bdcc-0242ac110003",
      "/explore/ashdonielle/posts/e133cd73-4e50-11ee-b620-0242ac110002",
      "/explore/Lexiwyatt/posts/5cd93a42-4cb7-11ee-b198-0242ac110003",
      "/explore/nestingwithgrace/posts/649830b8-48e6-11ee-a50b-0242ac110003",
    ],
  },
};
